// extracted by mini-css-extract-plugin
export var blogButton = "Button-module--blogButton--ff235";
export var blogButtonActive = "Button-module--blogButtonActive--5f0fa";
export var blogPagination = "Button-module--blogPagination--9135d";
export var blogPaginationActive = "Button-module--blogPaginationActive--b6a13";
export var blogPaginationArrow = "Button-module--blogPaginationArrow--cd41c";
export var brightBlue = "Button-module--brightBlue--da5bf";
export var button = "Button-module--button--c17ef";
export var darkBlue = "Button-module--darkBlue--e2b24";
export var link = "Button-module--link--c7764";
export var white = "Button-module--white--9e6ff";